import React from "react";
import {
	styledSystem as ss,
	theme,
	classNames,
	TClassName
} from ".";

interface IBoxCustomProps {
	renderIf?: boolean;
	condition?: boolean;
	cname?: TClassName;
	wrapIf?: boolean;
	className?: string | any;
}

type IDivBoxProps =
	ss.ICommonProps &
	ss.IBorderProps &
	ss.IFontSizeProps &
	ss.IFlexProps &
	ss.IGridProps &
	ss.ILayoutProps &
	ss.IPositionProps &
	ss.ITypographyProps &
	{ clearfix?: boolean }
;
const all = ss.compose(ss.COMMON, ss.BORDER, ss.FLEX, ss.GRID, ss.LAYOUT, ss.POSITION, ss.TYPOGRAPHY);

export type IBoxProps = IBoxCustomProps & IDivBoxProps & Omit<JSX.IntrinsicElements["div"], "ref">;

// We define this so that props that are not supported are removed
export const DivBox = ss.styled.div<IDivBoxProps>`
	${all}
	${ss.FONTSIZE}

	// Add clearfix to any box
	${props => props.clearfix ? `
		&::before {
			display: table;
			content: "";
		}
		&::after {
			display: table;
			clear: both;
			content: "";
		}
	` : undefined }
`;

DivBox.defaultProps = {
	theme,
};

export const Box = ({renderIf, condition, wrapIf, cname, ...props}: React.ComponentProps<typeof DivBox>) => {
	const className = cname ? classNames(cname, props.className) : undefined;
	if (renderIf === false || condition === false) {
		return null;
	}
	if (wrapIf === false) {
		return <>{props.children}</>;
	}
	return <DivBox className={className} {...props} />;
};